import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EditTranslationDto, CategoryBase, TemplateDto, CategoryTranslationCollectionDto } from '../../shared/model';
import { DataService } from '../../data.service';

@Injectable({
  providedIn: 'root'
})
export class KeywordsViewService {

  constructor(private dataService: DataService) { }

  addKeyword(keyword: EditTranslationDto): Observable<any> {
    return this.dataService.post('Keyword/AddKeywordWithTranslation', keyword);
  }

  editKeyword(keyword: EditTranslationDto): Observable<any> {
    return this.dataService.put('Keyword/EditKeyword', keyword);
  }

  deleteKeyword(keyword: string): Observable<any> {
    return this.dataService.delete('Keyword/DeleteKeyword', {keyword: keyword});
  }

  getTranslations(): Observable<any> {
    return this.dataService.get('Keyword/GetAllTranslationsByCategory', {});
  }

  editCategory(category: CategoryBase): Observable<any> {
    return this.dataService.put('Category/EditCategory', category);
  }

  getDescriptions(): Observable<any> {
    return this.dataService.get('Description/GetDescriptions', {});
  }

  setDescriptionVerified(descriptionId: number): Observable<any> {
    return this.dataService.put('Description/SetDescriptionVerified', descriptionId);
  }

  getComadaSuggestions(template: TemplateDto): Observable<any> {
    return this.dataService.post('KeywordSuggestions', template);
  }

  getAllCategoryTranslations(): Observable<any> {
    return this.dataService.get('Translations/GetAllCategoryTranslations', {});
  }

  editCategoryTranslations(translation: CategoryTranslationCollectionDto): Observable<any> {
    return this.dataService.put('Translations/EditCategoryTranslations', translation);
  }
}
